export const CM_FIXED_COLUMN_IDS = ["select", "application", "assetName"];

/** On-screen column order — a port of the order g360's `buildCmColumns` emits. */
export const CM_COLUMN_ORDER = [
  "application",
  "applicationCriticality",
  "pluginId",
  "pluginName",
  "auditFile",
  "severity",
  "compliance",
  "assetScore",
  "category",
  "environment",
  "assetName",
  "assetType",
  "ip",
  "port",
  "operatingSystem",
  "firstSeenDate",
  "firstLoggedDate",
  "lastSeenDate",
  "age",
  "overdue",
  "status",
  "actionOwner",
  "targetDate",
  "approvedDate",
  "details",
];

export const CM_DEFAULT_HIDDEN_COLUMN_IDS = new Set([
  "applicationCriticality",
  "assetScore",
  "category",
  "environment",
  "assetType",
  "port",
  "operatingSystem",
  "firstSeenDate",
  "firstLoggedDate",
  "lastSeenDate",
  "overdue",
  "actionOwner",
  "targetDate",
  "approvedDate",
]);

export const CM_OVERVIEW_FIXED_COLUMN_IDS = ["application", "assetName"];

export const CM_OVERVIEW_DEFAULT_HIDDEN_COLUMN_IDS = new Set([
  "applicationCriticality",
  "assetScore",
  "assetType",
  "category",
  "environment",
  "port",
  "operatingSystem",
  "firstSeenDate",
  "firstLoggedDate",
  "lastSeenDate",
  "overdue",
  "targetDate",
  "approvedDate",
  "actionOwner",
]);

export const CM_DEFAULT_VISIBLE_COLUMN_IDS = new Set(
  CM_COLUMN_ORDER.filter((id) => !CM_FIXED_COLUMN_IDS.includes(id) && !CM_DEFAULT_HIDDEN_COLUMN_IDS.has(id)),
);

export const CM_CISO_DEFAULT_HIDDEN_COLUMN_IDS = new Set([
  ...CM_DEFAULT_HIDDEN_COLUMN_IDS,
  "actionPlan",
  "requestedBy",
  "requestedOn",
  "requestId",
]);

export const CM_CISO_COLUMN_ORDER = [
  "application",
  "applicationCriticality",
  "pluginId",
  "pluginName",
  "requestedBy",
  "requestId",
  "requestedOn",
  "auditFile",
  "severity",
  "compliance",
  "assetScore",
  "environment",
  "assetName",
  "assetType",
  "ip",
  "port",
  "operatingSystem",
  "firstSeenDate",
  "firstLoggedDate",
  "lastSeenDate",
  "age",
  "overdue",
  "actionPlan",
  "targetDate",
  "approvedDate",
  "status",
  "actionOwner",
  "details",
];
